import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AmcService } from 'src/app/private/services/amc.service';
import { PaymentService } from 'src/app/private/services/payment.service';
import { PricingDashboardService } from 'src/app/private/services/pricing-dashboard.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

declare var Razorpay: any;

@Component({
  selector: 'app-pricing-dashboard',
  templateUrl: './pricing-dashboard.component.html',
  styleUrls: ['./pricing-dashboard.component.scss'],
})
export class PricingDashboardComponent {
  serviceData: any = [];
  selectedDuration: any;
  cartArray: any = [];
  selectionValue: any = [];
  loading: Boolean = false;
  totalAmount: any = 0;
  active:any = "package"
  packages:any = [];

   orderData:any = {
    orderId: "ORD" + Date.now(),
    tId: new Date().getTime(),
    amount: 0, // Amount in INR (e.g., 1000 for ₹10.00)
    currency: 'INR',
    language: 'EN',
    billing_name: '',
    billing_email: '',
    billing_tel: '',
    billing_address: '',
    billing_city: '',
    billing_state: '',
    billing_zip: '',
    billing_country: ''
  };
  constructor(
    private api: PricingDashboardService,
    private offcanvasService: NgbOffcanvas,
    private toast: ToastrService,
    private amc_service:AmcService,
    private localStorage: LocalStorageService,
    private paymentService: PaymentService
  ) {
     
    this.orderData.billing_name = this.localStorage.getHospitalName();
    this.orderData.billing_email = "";
    this.orderData.billing_tel = "";
    this.orderData.billing_address = this.localStorage.getHospitalAddress();
    this.orderData.billing_city = "";
    this.orderData.billing_state = "";
    this.orderData.billing_zip = "";
    this.orderData.billing_country = "India"; 
    this.orderData.amount = 0; // Amount in INR (e.g., 1000 for ₹10.00)
    this.orderData.currency = 'INR';
    this.orderData.language = 'EN'; // Set the language to English (EN)
    this.orderData.orderId = "ORD" + Date.now(); // Generate a unique order ID
    this.orderData.tId = new Date().getTime(); // Generate a unique transaction ID
    this.orderData.other = {}

    
  }




  @ViewChild('ccavenuePaymentForm', { static: false }) paymentForm!: ElementRef<HTMLFormElement>;

  openPaymentWindow() {
    const form = this.paymentForm.nativeElement;
    form.submit();
  }
  loadPackages(){
    this.amc_service.getPackages({}).subscribe({
      next:(res)=>{
        if(res){
        this.packages = res;
        }
      }
    })
  }
  changeTab(type:any) {
    this.active = type;
  }
  ngOnInit(): void {
    this.loadPackages();
    this.getAddOnService();
  }
  getFeatureKeys(details: any): string[] {
    return Object.keys(details);
  }
  sanitizeAndCapitalize(text: string): string {
    return text
      .replace(/[_\-]+/g, ' ') // Replace _ and - with spaces
      .replace(/[^a-zA-Z0-9 ]/g, '') // Remove other special characters
      .toLowerCase() // Convert to lowercase first
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
  }
  getAddOnService() {
    const payload = {
      status: true,
    };
    this.loading = true;
    this.api.getAddOnService(payload).subscribe({
      next: (response) => {
        this.loading = false;
        this.serviceData = response;
        this.serviceData.map((val: any, ind: any) => {
          this.selectionValue.push({ selectedValue: {} });
        });
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  isAlready(ind: any) {
    if (
      this.cartArray.find(
        (element: any) =>
          element['service'] === this.selectionValue[ind]['service']
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  updateCart(ind: any) {
    if (this.isAlready(ind)) {
      const index = this.cartArray.findIndex(
        (val: any) => val['service'] === this.selectionValue[ind]['service']
      );
      this.cartArray[index] = this.selectionValue[ind];
    }
  }

  removeFromCart(ind: any) {
    const index = this.cartArray.findIndex(
      (val: any) => val['service'] === this.selectionValue[ind]['service']
    );
    this.selectionValue[ind] = { selectedValue: {} };
    this.cartArray.splice(index, 1);
  }

  addToCart(ind: any) {
    if (this.isAlready(ind)) {
      const index = this.cartArray.findIndex(
        (val: any) => val['service'] === this.selectionValue[ind]['service']
      );
      this.cartArray[index] = this.selectionValue[ind];
    } else {
      this.cartArray.push(this.selectionValue[ind]);
    }
  }

  OpenCart(content: TemplateRef<any>) {
    this.totalAmount = 0;
    this.cartArray.map((val: any) => {
      this.totalAmount += parseInt(val['selectedValue']['price']);
    });
    this.offcanvasService.open(content, { position: 'end' });
  }

  payNow(packageData:any) {
    if (this.paymentForm && this.paymentForm.nativeElement) {
      //alert(packageData.price.toString())
       this.orderData.amount = window.btoa(packageData.price.toString())
       this.orderData.other = window.btoa(JSON.stringify([this.localStorage.getHospitalId(),packageData.id])) ;
       const form = this.paymentForm.nativeElement;
       if(this.orderData.amount == undefined || this.orderData.amount== null || this.orderData.amount== 0){ 
        this.toast.error("Please select at least one service", "Error", {
          timeOut: 3000,
        });
        return
      }
        else {
          setTimeout(() => {
            form.submit();
            this.orderData.orderId = "ORD" + Date.now(); // Generate a unique order ID
            this.orderData.tId = new Date().getTime(); // Generate a unique transaction ID
            this.orderData.other = {}
            this.orderData.amount = 0; 
          }, 1000);
        }
      
    
    } else {
      console.error('Payment form is not available.');
    }
  }
  checkOut() {  
   if(this.cartArray.length == 0){
    this.toast.error("Please select at least one service", "Error", {
      timeOut: 3000,
    });
    return
  }
  else if(this.selectedDuration == undefined){
    this.toast.error("Please select duration", "Error", {
      timeOut: 3000,
    });
    return
  }
  else {

  }
}
  redirectToCCAvenue(formHtml: string) {
    const div = document.createElement('div');
    div.innerHTML = formHtml;
    document.body.appendChild(div);
    const form = document.getElementById('ccavenueForm') as HTMLFormElement;
    form.submit();
  }

  // payNow() {
  //   const toaster = this.toast;
  //   const off = this.offcanvasService;
  //   const RazorpayOptions = {
  //     description: 'Sample Razorpay demo',
  //     currency: 'INR',
  //     amount: 100 * this.totalAmount, // Amount in paisa (1000 INR)
  //     name: 'Rudhram',
  //     key: 'rzp_test_yXSy4v6XGiTsdg', // Your Razorpay Key Id
  //     image: 'https://tina.gravitasai.com/emr/assets/img/mainlogo.png',
  //     prefill: {
  //       name: 'Rudhram Saraswat',
  //       email: 'rudhram@gmail.com',
  //       contact: '9587909621', // Use 'contact' instead of 'phone'
  //     },
  //     handler: function (response: any) {
  //       console.log('done');
  //       console.log(response);
  //       off.dismiss('Cross click');
  //       toaster.success('Payment Successful', 'Success', {
  //         timeOut: 3000,
  //       });
  //       resetVal();
  //     },
  //     theme: {
  //       color: '#6466e3',
  //     },
  //     modal: {
  //       ondismiss: () => {
  //         console.log('dismissed');
  //       },
  //     },
  //   };

  //   const resetVal = () => {
  //     this.cartArray = [];
  //     this.selectionValue.map((val: any, ind: any) => {
  //       this.selectionValue[ind] = { selectedValue: {} };
  //     });
  //   };

  //   const pay = Razorpay.open(RazorpayOptions);
  //   pay.on('payment.failed', function (response: any) {
  //     console.log(response.error.code);
  //     console.log(response.error.description);
  //     console.log(response.error.source);
  //     console.log(response.error.step);
  //     console.log(response.error.reason);
  //     console.log(response.error.metadata.order_id);
  //     console.log(response.error.metadata.payment_id);
  //   });
  // }
}
